import type { useTranslations } from 'next-intl'

export function knowledgeSourceStatusLabel(status: 'pending' | 'synced' | 'failed' | 'inaccessible' | 'skipped', t: ReturnType<typeof useTranslations<'KnowledgeSources'>>) {
  switch (status) {
    case 'pending': return t('syncing')
    case 'synced': return t('imported')
    case 'failed': return t('failed')
    case 'inaccessible': return t('inaccessible')
    case 'skipped': return t('skipped')
  }
}
